<script>
export default {
  name: 'ChartBarIconWarning',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#EC9C00',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando a máscara nas instâncias duplicadas.
    maskId() {
      return `mask0_5977_5076_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.499 13.752L10.5709 10.9681L13.3553 8.18316L11.499 13.752ZM12.6482 7.47612L9.86377 10.2605L7.07936 9.3324L12.6482 7.47612ZM14.9945 6.30594C14.992 6.25944 14.9835 6.21443 14.968 6.17092C14.963 6.15542 14.9575 6.14042 14.9505 6.12542C14.9265 6.07191 14.896 6.0214 14.853 5.9784C14.81 5.93539 14.7595 5.90488 14.7055 5.88088C14.691 5.87388 14.6765 5.86838 14.661 5.86338C14.6165 5.84788 14.571 5.83887 14.5235 5.83637C14.5125 5.83587 14.5025 5.83337 14.491 5.83337C14.441 5.83437 14.3905 5.84138 14.3414 5.85738L5.3401 8.85783C5.13557 8.92634 4.99805 9.11687 4.99805 9.3324C4.99805 9.54793 5.13557 9.73896 5.3401 9.80697L9.60324 11.2282L11.025 15.4918C11.093 15.6959 11.2835 15.8334 11.499 15.8334C11.7146 15.8334 11.9051 15.6959 11.9731 15.4918L14.9735 6.49047C14.9895 6.44097 14.997 6.39096 14.9975 6.34095C14.998 6.32895 14.995 6.31795 14.9945 6.30594Z"
      fill="#231F20"
    />
    <mask
      :id="maskId"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="18"
      height="18"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4969 9.14508H17.4994C17.9586 9.14508 18.3319 9.51675 18.3327 9.97591C18.3394 12.2017 17.4786 14.2976 15.9086 15.8759C14.3394 17.4542 12.2494 18.3267 10.0236 18.3334H9.99939C7.78189 18.3334 5.69605 17.4734 4.12355 15.9092C2.54522 14.3401 1.67272 12.2501 1.66605 10.0242C1.65939 7.79758 2.52022 5.70258 4.09022 4.12425C5.65939 2.54591 7.74939 1.67341 9.97522 1.66675C10.6377 1.67675 11.3127 1.74341 11.9594 1.89841C12.4061 2.00675 12.6819 2.45675 12.5736 2.90425C12.4661 3.35091 12.0136 3.62591 11.5686 3.51925C11.0511 3.39425 10.5019 3.34175 9.98022 3.33341C8.19939 3.33841 6.52689 4.03675 5.27189 5.29925C4.01605 6.56175 3.32772 8.23841 3.33272 10.0192C3.33772 11.8001 4.03605 13.4717 5.29855 14.7276C6.55689 15.9784 8.22522 16.6667 9.99939 16.6667H10.0186C11.7994 16.6617 13.4719 15.9634 14.7269 14.7009C15.9827 13.4376 16.6711 11.7617 16.6661 9.98092C16.6652 9.52091 17.0369 9.14591 17.4969 9.14508ZM10.5696 10.9681L11.4977 13.752L13.354 8.1832L10.5696 10.9681ZM9.86248 10.2606L12.6469 7.47616L7.07806 9.33244L9.86248 10.2606ZM14.9668 6.17097C14.9823 6.21447 14.9908 6.25948 14.9933 6.30599C14.9935 6.31103 14.9941 6.3159 14.9948 6.32073C14.9957 6.32741 14.9965 6.33403 14.9963 6.34099C14.9958 6.391 14.9883 6.44101 14.9723 6.49051L11.9718 15.4919C11.9038 15.6959 11.7133 15.8334 11.4977 15.8334C11.2822 15.8334 11.0917 15.6959 11.0237 15.4919L9.60195 11.2282L5.33881 9.80701C5.13428 9.739 4.99675 9.54797 4.99675 9.33244C4.99675 9.11691 5.13428 8.92638 5.33881 8.85787L14.3402 5.85742C14.3892 5.84142 14.4397 5.83441 14.4897 5.83342C14.4961 5.83342 14.5021 5.8342 14.508 5.83497C14.5127 5.83558 14.5173 5.83619 14.5222 5.83642C14.5697 5.83892 14.6152 5.84792 14.6597 5.86342C14.6752 5.86842 14.6897 5.87392 14.7042 5.88092C14.7582 5.90493 14.8087 5.93543 14.8517 5.97844C14.8947 6.02144 14.9252 6.07195 14.9492 6.12546C14.9562 6.14046 14.9618 6.15546 14.9668 6.17097Z"
        fill="white"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <rect width="20" height="20" :fill="color" />
    </g>
  </svg>
</template>
